import Money from './Money';

/**
 * Список «підпис — сума», який раніше вручну верстався на п'яти екранах
 * однаковим набором PrimeFlex-класів.
 */
export const SummaryRow = ({ label, sublabel, value, total = false, children }) => (
    <li className={`rc-summary-row ${total ? 'rc-summary-row--total' : ''}`.trim()}>
        <div className="rc-summary-row__label">
            {label}
            {sublabel && <span className="rc-summary-row__sub">{sublabel}</span>}
        </div>
        <div className="rc-summary-row__value">{children ?? value}</div>
    </li>
);

/**
 * @param {Array<{currency: string, sum?: number, amount?: number}>} amounts
 */
export const AmountRows = ({ amounts = [], tone, keyPrefix = 'amount' }) =>
    amounts.map((item, index) => (
        <SummaryRow key={`${keyPrefix}-${item.currency}-${index}`} label={item.currency}>
            <Money value={item.sum ?? item.amount} currency={item.currency} tone={tone} />
        </SummaryRow>
    ));

const SummaryList = ({ children, className = '' }) => (
    <ul className={`rc-summary-list ${className}`.trim()}>{children}</ul>
);

export default SummaryList;
